import { Component } from "@angular/core";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import RouteNameConstants from "src/app/constants/route-name-constants";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.scss"],
  standalone: false,
})
export class NotFoundComponent {
  readonly routeNameConstants = RouteNameConstants;

  faSearch = faSearch;

  constructor() {}
}
